import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_3 = { class: "card-body p-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_9 = { class: "d-flex align-items-center gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "material-symbols-outlined fs-24 text-primary"
}
const _hoisted_11 = { class: "col-lg-6 col-md-6 mb-4" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 mb-4 d-flex align-items-center" }
const _hoisted_13 = { class: "form-check form-switch mt-2" }
const _hoisted_14 = { class: "col-lg-12 col-md-12 mb-4" }
const _hoisted_15 = { class: "form-label text-dark fs-14 fw-medium d-flex justify-content-between align-items-center" }
const _hoisted_16 = { class: "fw-bold fs-14 text-muted" }
const _hoisted_17 = ["onUpdate:modelValue"]
const _hoisted_18 = ["onClick", "disabled"]
const _hoisted_19 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, {
      pageTitle: _ctx.isEditing ? 'Edit Tutorial' : 'Add Tutorial',
      subTitle: "Management"
    }, null, 8, ["pageTitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                placeholder: "Enter tutorial title",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.title]
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Service", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.service_id) = $event)),
                required: ""
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Select a service", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: service.service_id,
                    value: service.service_id
                  }, _toDisplayString(service.service_name), 9, _hoisted_7))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.service_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Material Icon", -1)),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.icon) = $event))
                }, _cache[10] || (_cache[10] = [
                  _createStaticVNode("<option value=\"\">-- No Icon --</option><option value=\"plagiarism\">Plagiarism</option><option value=\"edit_document\">Edit Document</option><option value=\"auto_fix_high\">Auto Fix High</option><option value=\"menu_book\">Menu Book (Journal)</option><option value=\"translate\">Translate</option><option value=\"school\">School / Tutorial</option><option value=\"info\">Info</option><option value=\"check_circle\">Check Circle</option><option value=\"upload_file\">Upload File</option><option value=\"contact_support\">Contact Support</option>", 11)
                ]), 512), [
                  [_vModelSelect, _ctx.form.icon]
                ]),
                (_ctx.form.icon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.form.icon), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-dark fs-14 fw-medium" }, "Order", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.order) = $event)),
                placeholder: "0",
                min: "0",
                required: ""
              }, null, 512), [
                [_vModelText, _ctx.form.order]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  id: "isActive",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.is_active) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.form.is_active]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  class: "form-check-label text-dark fs-14 fw-medium",
                  for: "isActive"
                }, "Active (Visible to users)", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, [
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Steps", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-sm btn-outline-primary py-1 px-2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addStep && _ctx.addStep(...args)))
                }, _cache[14] || (_cache[14] = [
                  _createElementVNode("i", { class: "ri-add-line me-1" }, null, -1),
                  _createTextVNode("Add Step ")
                ]))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.steps, (step, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex mb-2 align-items-center gap-2"
                }, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(index + 1) + ".", 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": ($event: any) => ((_ctx.form.steps[index]) = $event),
                    placeholder: "Enter step description",
                    required: ""
                  }, null, 8, _hoisted_17), [
                    [_vModelText, _ctx.form.steps[index]]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-danger p-2 lh-1",
                    onClick: ($event: any) => (_ctx.removeStep(index)),
                    disabled: _ctx.form.steps.length <= 1
                  }, _cache[16] || (_cache[16] = [
                    _createElementVNode("i", { class: "material-symbols-outlined fs-18" }, "delete", -1)
                  ]), 8, _hoisted_18)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_RouterLink, {
              to: "/tutorials",
              class: "btn btn-secondary fs-15 fw-medium"
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode("Cancel")
              ])),
              _: 1
            }),
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-primary fs-15 fw-medium",
              disabled: _ctx.loading
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.isEditing ? 'Update Tutorial' : 'Create Tutorial'), 1)
            ], 8, _hoisted_20)
          ])
        ], 32)
      ])
    ])
  ]))
}